import React from "react";
import { IoDocumentText } from "react-icons/io5";
import { FaGithub } from "react-icons/fa";
import { IoLogoLinkedin } from "react-icons/io5";
import { IoMdMail } from "react-icons/io";

const Intro = () => {
  return (
    <section className="border-b border-zinc-200 bg-white text-zinc-950 dark:border-zinc-800 dark:bg-zinc-950 dark:text-white">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-6 py-12 text-center sm:flex-row sm:items-center sm:gap-8 sm:text-left">
        <img
          src={`${process.env.PUBLIC_URL}/1754886728692.jpg`}
          alt="Milad Mehri"
          className="mb-5 h-32 w-32 rounded-md border border-zinc-200 object-cover shadow-sm sm:mb-0 dark:border-zinc-800"
        />

        <div>
          <h1 className="mb-2 text-3xl font-semibold leading-tight sm:text-4xl">
            Milad Mehri
          </h1>

          <p className="mb-2 text-base text-zinc-700 dark:text-zinc-300">
            SDE Intern at{" "}
            <a
              className="font-medium text-zinc-950 underline decoration-zinc-300 underline-offset-4 hover:decoration-zinc-950 dark:text-white dark:decoration-zinc-600 dark:hover:decoration-white"
              href="https://www.linkedin.com/company/amazon/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Amazon
            </a>{" "}
            · CS at{" "}
            <a
              className="font-medium text-zinc-950 underline decoration-zinc-300 underline-offset-4 hover:decoration-zinc-950 dark:text-white dark:decoration-zinc-600 dark:hover:decoration-white"
              href="https://www.cs.ubc.ca/"
              target="_blank"
              rel="noopener noreferrer"
            >
              UBC
            </a>
          </p>

          <p className="mb-5 max-w-xl text-sm leading-6 text-zinc-600 dark:text-zinc-400">
            Building full-stack products, distributed systems, and applied AI tools.
          </p>

          <div className="flex justify-center gap-4 sm:justify-start">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/MiladMehriResume.pdf"
            aria-label="View resume"
            className="text-zinc-600 hover:text-zinc-950 dark:text-zinc-400 dark:hover:text-white"
          >
            <IoDocumentText size={22} />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/milad-mehri"
            aria-label="View GitHub"
            className="text-zinc-600 hover:text-zinc-950 dark:text-zinc-400 dark:hover:text-white"
          >
            <FaGithub size={22} />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/in/milad-mehri1/"
            aria-label="View LinkedIn"
            className="text-zinc-600 hover:text-zinc-950 dark:text-zinc-400 dark:hover:text-white"
          >
            <IoLogoLinkedin size={22} />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:memm.milad@gmail.com"
            aria-label="Email Milad"
            className="text-zinc-600 hover:text-zinc-950 dark:text-zinc-400 dark:hover:text-white"
          >
            <IoMdMail size={22} />
          </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
